'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('redux/modules/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _base2.default('tags', 'Mot-clé');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/tags.js
// module id = 108
// module chunks = 0